export default __webpack_public_path__ + "static/Reklamacny_poriadok_Autoskola_Hron_sro-72afe5b612d5cd724612b969b2ae3d9e.pdf";